(function(){
function safe(n,f){try{f()}catch(e){try{console.warn('sgy-home ['+n+']',e)}catch(_){}}}

/* Reveal runs first so page content can never be left hidden by an unrelated error. */
safe('reveal',function(){
// Reveal on scroll
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('on');io.unobserve(e.target)}}),{threshold:.14});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
});
safe('counters',function(){
// Counters
const co=new IntersectionObserver(es=>es.forEach(e=>{if(!e.isIntersecting)return;const el=e.target,end=+el.dataset.count;let t0=null;const step=ts=>{if(!t0)t0=ts;const p=Math.min((ts-t0)/1400,1);el.textContent=Math.floor(end*(1-Math.pow(1-p,3)));if(p<1)requestAnimationFrame(step)};requestAnimationFrame(step);co.unobserve(el)}),{threshold:.5});
document.querySelectorAll('[data-count]').forEach(el=>co.observe(el));
});
safe('arrivals',function(){
// New arrivals scroll
const naRow=document.getElementById('naRow');
document.querySelectorAll('[data-na]').forEach(b=>b.addEventListener('click',()=>naRow.scrollBy({left:+b.dataset.na*(258*2),behavior:'smooth'})));
});
safe('hd-stub',function(){
// Sticky header shrink
const hd=document.getElementById('hd');
addEventListener('scroll',()=>{hd.classList.toggle('small',scrollY>40)},{passive:true});
});
safe('search-stub',function(){
// Search expand
const srch=document.getElementById('srch');
document.getElementById('srchBtn').addEventListener('click',()=>{
  if(srch.classList.contains('open')){const q=document.getElementById('srchIn').value.trim();if(q){location.href='https://seoulogy.com/search?q='+encodeURIComponent(q);return}}
  srch.classList.toggle('open');if(srch.classList.contains('open'))document.getElementById('srchIn').focus();
});
document.getElementById('srchIn').addEventListener('keydown',e=>{if(e.key==='Enter'){const q=e.target.value.trim();if(q)location.href='https://seoulogy.com/search?q='+encodeURIComponent(q)}});
});
safe('mnav-stub',function(){
// Mobile menu
const mnav=document.getElementById('mnav');
document.getElementById('burger').addEventListener('click',()=>mnav.classList.toggle('open'));
});
safe('call-modal',function(){
// Call request modal
const cmodal=document.getElementById('cmodal');
const steps=[...cmodal.querySelectorAll('.cstep')];
const dots=[...cmodal.querySelectorAll('.cstep-dots i')];
function goStep(n){steps.forEach(s=>s.style.display=+s.dataset.step===n?'block':'none');dots.forEach((d,i)=>d.classList.toggle('on',i<n&&n<4));}
document.querySelectorAll('[data-callmodal]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();cmodal.classList.add('open');document.body.style.overflow='hidden';goStep(1)}));
cmodal.querySelectorAll('[data-cclose]').forEach(b=>b.addEventListener('click',()=>{cmodal.classList.remove('open');document.body.style.overflow=''}));
cmodal.querySelectorAll('[data-cback]').forEach(b=>b.addEventListener('click',()=>{const cur=steps.findIndex(s=>s.style.display!=='none')+1;goStep(cur-1)}));
// single + multi selects
document.querySelectorAll('#bizOpt button, #slotOpt button').forEach(b=>b.addEventListener('click',()=>{b.parentElement.querySelectorAll('button').forEach(x=>x.classList.remove('on'));b.classList.add('on')}));
document.querySelectorAll('#topicOpt button').forEach(b=>b.addEventListener('click',()=>b.classList.toggle('on')));
// generate next 8 working days
const dayWrap=document.getElementById('dayOpt');
const fmtD=new Intl.DateTimeFormat('en-GB',{weekday:'short'});const fmtM=new Intl.DateTimeFormat('en-GB',{month:'short'});
let d=new Date();let added=0;
while(added<8){d.setDate(d.getDate()+1);const wd=d.getDay();if(wd===0||wd===6)continue;const b=document.createElement('button');b.innerHTML=`<span>${fmtD.format(d)}</span><b>${d.getDate()}</b><span>${fmtM.format(d)}</span>`;b.addEventListener('click',()=>{dayWrap.querySelectorAll('button').forEach(x=>x.classList.remove('on'));b.classList.add('on')});dayWrap.appendChild(b);added++}
document.getElementById('cNext1').addEventListener('click',()=>goStep(2));
document.getElementById('cNext2').addEventListener('click',()=>goStep(3));
document.getElementById('cSubmit').addEventListener('click',()=>{
  const need=[['cName','name'],['cBiz','business name'],['cEmail','email']];
  for(const [id] of need){const el=document.getElementById(id);if(!el.value.trim()){el.style.borderColor='#b3423a';el.focus();return}}
  goStep(4);dots.forEach(d=>d.classList.add('on'));
});
});

safe('journey-ingredients',function(){
/* UNIFIED JOURNEY + INGREDIENT SYSTEM (contained) */
(function(){
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Journey paths: none open on load, one at a time, toggle to close
  var tabs=[document.getElementById('jtab1'),document.getElementById('jtab2'),document.getElementById('jtab3')];
  var wraps=[document.getElementById('jc1'),document.getElementById('jc2'),document.getElementById('jc3')];
  var panels=[document.getElementById('jpanel1'),document.getElementById('jpanel2'),document.getElementById('jpanel3')];
  var open=-1;
  function set(i,state){
    tabs[i].setAttribute('aria-expanded',state?'true':'false');
    if(state){panels[i].hidden=false;requestAnimationFrame(function(){wraps[i].classList.add('open')});}
    else{wraps[i].classList.remove('open');setTimeout(function(){if(open!==i)panels[i].hidden=true;},430);}
  }
  tabs.forEach(function(t,i){
    t.addEventListener('click',function(){
      if(open===i){set(i,false);open=-1;return;}
      if(open>-1)set(open,false);
      open=i;set(i,true);
    });
    t.addEventListener('keydown',function(e){
      var n=null;
      if(e.key==='ArrowRight'||e.key==='ArrowDown')n=(i+1)%3;
      if(e.key==='ArrowLeft'||e.key==='ArrowUp')n=(i-1+3)%3;
      if(e.key==='Home')n=0;
      if(e.key==='End')n=2;
      if(n!==null){e.preventDefault();tabs[n].focus();}
    });
  });

  /*
    SEOUL SIGNAL TOPICS: set approved:true and supply approved content to display a
    topic inside path two. Topics without approved content stay hidden and no
    placeholder editorial copy is ever shown publicly.
  */
  var SGY_TOPICS=[
    {approved:false,label:"Ingredient watch"},
    {approved:false,label:"Treatment innovation"},
    {approved:false,label:"Professional format"}
  ];
  var topicWrap=document.getElementById('sgyTopics');
  if(SGY_TOPICS.some(function(t){return t.approved})){topicWrap.hidden=false;}

  // Explore New Arrivals
  document.getElementById('sgyGoNA').addEventListener('click',function(){
    document.getElementById('new-arrivals').scrollIntoView({behavior:reduce?'auto':'smooth'});
  });

  // Consumer notify form (front end confirmation; connect to the store's email platform on deployment)
  document.getElementById('sgyNotify').addEventListener('click',function(){
    var mail=document.getElementById('fMail');
    if(!mail.value.trim()||mail.value.indexOf('@')<0){mail.style.borderColor='#b3423a';mail.focus();return;}
    mail.style.borderColor='';
    document.getElementById('sgySoon').hidden=false;
  });

  /*
    INGREDIENT DATA: every entry below only uses information already present on this
    page (feature sections, product cards and collection tiles). Fields without
    approved supporting content are omitted per entry and their rows are hidden.
    The structure supports up to eight ingredients; add new entries with the same
    field names once approved content exists.
  */
  var ING=[
    {name:"Volufiline™",cat:"Volume active",short:"Topical volume enhancing active for sculpted facial contours.",
     what:"A patented extract from Anemarrhena asphodeloides that stimulates lipid accumulation in the skin, one of the few topical actives shown to increase adipocyte volume rather than simply hydrate.",
     rel:"Subtle plumping of cheek volume begins at around +2.2% volume density, building progressively across a treatment course.",
     concern:"Loss of facial volume",application:"Lifting and contour facials",prodName:"Krx Youthplex Face Lift line",
     url:"https://seoulogy.com/products/krx-youthplex-toning-solution",img:"https://seoulogy.com/cdn/shop/files/Carousel_Posts_-_Krx_Aesthetics_7.png"},
    {name:"Spicules",cat:"Bio microneedling",short:"Hydrolysed sponge needle crystals.",
     what:"Microscopically fine silicate needles from freshwater sponge. Massaged into the skin, they create micro channels mechanically, with no thermal or chemical trauma, unlike acids.",
     rel:"In the first 24 hours around 300,000 microchannels are created, stimulating circulation and cell turnover as renewal begins.",
     concern:"Texture and renewal",application:"Bio microneedling peels",prodName:"Krx Green Sea Peel",
     url:"https://seoulogy.com/products/green-sea-peel-liquid-bio-microneedling",img:"https://seoulogy.com/cdn/shop/files/20250715_1228_Dark_Aesthetic_Powder_Design_remix_01k06xbwv2fetv7qskt4am1md5.png"},
    {name:"EGF + FGF Complex",cat:"Growth factors",short:"Growth factor duo for wrinkle repair and epidermal renewal.",
     what:"A biomimetic peptide pair that mimics endogenous growth factor signalling to support keratinocyte activity and epidermal renewal.",
     rel:"Epidermal healing support begins within the first 24 hours, used clinically in post laser and post microneedling care.",
     concern:"Wrinkles and repair",application:"Post treatment renewal",prodName:"Dermathod EGF Multi Effector Ampoule",
     url:"https://seoulogy.com/products/dermathod-egf-multi-effector-ampoule-coming-soon",img:"https://seoulogy.com/cdn/shop/files/Carousel_Posts_-_Krx_Aesthetics_6.png"},
    {name:"PDRN",cat:"Regeneration",short:"The regenerative active behind the highest purity PDRN in the UK and Korea, 508,000 ppm.",
     what:"Derived to the highest purity standard, 50.8% PDRN, in the Permatology EXO-PDRN Recovery Ampoule.",
     rel:"After a single microneedling treatment, skin shows visible improvement in firmness and recovery.",
     concern:"Firmness and recovery",application:"Regeneration protocols",prodName:"Permatology EXO-PDRN Recovery Ampoule",
     url:"https://seoulogy.com/products/permatology-exo-pdrn-recovery-ampoule",img:"https://seoulogy.com/cdn/shop/files/Ampoule_4.jpg"},
    {name:"PLLA",cat:"Skin booster",short:"Featured in the ISOV Derma Matrix PLLA Skin Booster Ampoule, new at Seoulogy.",
     what:"",rel:"",concern:"",application:"",prodName:"ISOV Derma Matrix PLLA Skin Booster Ampoule",
     url:"https://seoulogy.com/products/isov-derma-matrix-plla-skin-booster-ampoule",
     img:"https://cdn.shopify.com/s/files/1/0788/7795/0284/files/2_e9c3538d-228b-4d5f-a9b2-af3803144dbc.png?v=1777558574"},
    {name:"Exosomes",cat:"Advanced regeneration",short:"An advanced regeneration category within the Seoulogy clinic essentials range.",
     what:"",rel:"",concern:"",application:"",prodName:"Exosomes collection",
     url:"https://seoulogy.com/collections/exosomes",img:"https://cdn.shopify.com/s/files/1/0788/7795/0284/files/ISOV_EXO_LLT_PRO_TRIFILLS_SOLUTION_Ampoule.png?v=1784714964"}
  ];
  var nav=document.getElementById('ingNav');
  var cur=0;
  ING.forEach(function(d,i){
    var b=document.createElement('button');
    b.className='sgy_ingitem';
    b.setAttribute('role','tab');
    b.setAttribute('aria-selected',i===0?'true':'false');
    b.setAttribute('aria-controls','ingStage');
    b.tabIndex=i===0?0:-1;
    b.innerHTML='<span><span class="no">'+String(i+1).padStart(2,'0')+'</span><span class="nm">'+d.name+'</span></span><span class="ct">'+d.cat+'</span>';
    b.addEventListener('click',function(){ingSet(i,false)});
    b.addEventListener('keydown',function(e){
      var n=null,len=ING.length;
      if(e.key==='ArrowRight')n=(i+1)%len;
      if(e.key==='ArrowLeft')n=(i-1+len)%len;
      if(e.key==='Home')n=0;
      if(e.key==='End')n=len-1;
      if(n!==null){e.preventDefault();ingSet(n,true);}
    });
    nav.appendChild(b);
  });
  var items=[].slice.call(nav.children);
  var stage=document.getElementById('ingStage');
  function show(id,on){document.getElementById(id).style.display=on?'':'none'}
  function apply(d){
    document.getElementById('ingName').textContent=d.name;
    document.getElementById('ingBigType').textContent=d.name.replace('™','');
    document.getElementById('ingCatLbl').textContent=d.cat;
    document.getElementById('ingShort').textContent=d.short;
    document.getElementById('ingWhat').textContent=d.what;
    document.getElementById('ingRel').textContent=d.rel;
    show('ingWhatWrap',!!d.what);show('ingRelWrap',!!d.rel);
    var img=document.getElementById('ingImg');
    var wash=document.getElementById('ingWash');
    if(d.img){img.src=d.img;img.alt=d.prodName;img.hidden=false;wash.hidden=false;img.onerror=function(){img.hidden=true;wash.hidden=true};}
    else{img.hidden=true;wash.hidden=true;img.removeAttribute('src');}
    var link=document.getElementById('ingLink');
    link.href=d.url;link.textContent=d.url.indexOf('/collections/')>-1?'Explore the collection':'View related product';
    var pw=document.getElementById('ingPathway');
    pw.innerHTML='';
    [['Ingredient',d.name],['Primary concern',d.concern],['Professional application',d.application],['Related product',d.prodName]].forEach(function(p){
      if(!p[1])return;
      var el=document.createElement('span');el.className='pw';
      el.innerHTML='<i>'+p[0]+'</i><b>'+p[1]+'</b>';
      pw.appendChild(el);
    });
  }
  function ingSet(i,focus){
    cur=i;
    items.forEach(function(t,x){var on=x===i;t.setAttribute('aria-selected',on?'true':'false');t.tabIndex=on?0:-1;});
    items[i].scrollIntoView({behavior:reduce?'auto':'smooth',block:'nearest',inline:'nearest'});
    if(reduce){apply(ING[i]);}
    else{
      stage.style.transition='opacity .3s,transform .3s';
      stage.style.opacity='0';stage.style.transform='translateX(12px)';
      setTimeout(function(){apply(ING[i]);stage.style.opacity='1';stage.style.transform='none';},300);
    }
    if(focus)items[i].focus();
    arrows();
  }
  function arrows(){
    document.getElementById('ingPrev').disabled=cur===0;
    document.getElementById('ingNext').disabled=cur===ING.length-1;
  }
  // preload the active and next slide images
  function preload(i){
    [i,i+1].forEach(function(x){
      if(x>=0&&x<ING.length&&ING[x].img){var im=new Image();im.src=ING[x].img;}
    });
  }
  var origIngSet=ingSet;
  ingSet=function(i,focus){origIngSet(i,focus);preload(i);};
  preload(0);
  // touch swipe on the stage (mobile)
  var swx=null;
  stage.addEventListener('pointerdown',function(e){swx=e.clientX});
  stage.addEventListener('pointerup',function(e){
    if(swx===null)return;
    var dx=e.clientX-swx;swx=null;
    if(Math.abs(dx)>48){
      if(dx<0&&cur<ING.length-1)ingSet(cur+1,false);
      if(dx>0&&cur>0)ingSet(cur-1,false);
    }
  });
  document.getElementById('ingPrev').addEventListener('click',function(){if(cur>0)ingSet(cur-1,false)});
  document.getElementById('ingNext').addEventListener('click',function(){if(cur<ING.length-1)ingSet(cur+1,false)});
  apply(ING[0]);arrows();
})();
});

safe('delight',function(){
/* DELIGHT LAYER (contained) */
(function(){
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  // announcement capsule
  var MSGS=['Empowering UK clinics with the world’s most advanced Korean skincare treatments','<b>Free UK delivery</b> on orders over £200','Order before <b>1pm</b> for same day dispatch from our UK warehouse'];
  var cap=document.getElementById('annCap'),el=document.getElementById('annMsg');
  if(cap){
    var idx=0,timer=null;
    function render(){el.innerHTML='<i>◆</i>'+MSGS[idx]+'<i>◆</i>';}
    function go(n){idx=(n+MSGS.length)%MSGS.length;if(reduce){render();return;}cap.classList.add('swap');setTimeout(function(){render();cap.classList.remove('swap');},350);}
    function play(){if(reduce)return;stop();timer=setInterval(function(){go(idx+1)},5000);}
    function stop(){if(timer){clearInterval(timer);timer=null;}}
    document.getElementById('annPrev').addEventListener('click',function(){go(idx-1);play();});
    document.getElementById('annNext').addEventListener('click',function(){go(idx+1);play();});
    cap.addEventListener('mouseenter',stop);cap.addEventListener('mouseleave',play);
    cap.addEventListener('focusin',stop);cap.addEventListener('focusout',play);
    render();play();
  }
  // scroll progress + hero parallax
  var prog=document.getElementById('sgyProg'),bg=document.querySelector('.hero-bg'),tick=false;
  function onScroll(){
    if(tick)return;tick=true;
    requestAnimationFrame(function(){
      var h=document.documentElement,max=h.scrollHeight-h.clientHeight;
      if(prog)prog.style.width=(max>0?(h.scrollTop/max*100):0)+'%';
      if(bg&&!reduce&&h.scrollTop<900)bg.style.transform='scale(1.06) translateY('+Math.min(40,h.scrollTop*.12)+'px)';
      tick=false;
    });
  }
  addEventListener('scroll',onScroll,{passive:true});onScroll();
  // hero words
  var h1=document.getElementById('heroH1');
  if(h1){var ws=h1.querySelectorAll('.w');ws.forEach(function(w,i){w.style.transitionDelay=(reduce?0:(.15+i*.06))+'s'});requestAnimationFrame(function(){h1.classList.add('on')});}
  // stat rings
  var rio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');rio.unobserve(e.target)}})},{threshold:.5});
  document.querySelectorAll('.stat').forEach(function(s){rio.observe(s)});
  // gliding pill behind journey selectors
  var paths=document.getElementById('sgyPaths'),pill=document.getElementById('sgyPill');
  function movePill(){
    if(!paths||!pill)return;
    var act=paths.querySelector('.sgy_path[aria-expanded="true"]');
    if(!act){pill.classList.remove('on');return;}
    var pr=paths.getBoundingClientRect(),ar=act.getBoundingClientRect();
    pill.style.width=ar.width+'px';pill.style.height=ar.height+'px';
    pill.style.transform='translate('+(ar.left-pr.left)+'px,'+(ar.top-pr.top)+'px)';
    pill.classList.add('on');
  }
  if(paths){
    new MutationObserver(movePill).observe(paths,{attributes:true,subtree:true,attributeFilter:['aria-expanded']});
    addEventListener('resize',movePill);
    movePill();
  }
})();
});

safe('linenize',function(){
(function(){
  ['.ing-band','.trad','.trade'].forEach(function(sel){
    var el=document.querySelector(sel); if(!el) return;
    el.classList.add('linenize');
    ['a','b','c'].forEach(function(k){var d=document.createElement('div');d.className='lpatch '+k;d.setAttribute('aria-hidden','true');el.appendChild(d);});
  });
  var hero=document.querySelector('.hero');
  if(hero){hero.classList.add('linenize');['a','b'].forEach(function(k){var d=document.createElement('div');d.className='lpatch '+k;d.setAttribute('aria-hidden','true');hero.appendChild(d);});}
})();
});
safe('video-nudge',function(){
  // iOS Low Power Mode and some data-saver browsers refuse video autoplay, so the
  // clip sat frozen on its poster. Retry inside the first user gesture, and if the
  // browser still refuses, reveal native controls so one tap starts it.
  var v=document.querySelector('.vid-card video');if(!v)return;
  function kick(){try{var p=v.play();if(p&&p.catch)p.catch(function(){v.controls=true;});}catch(e){v.controls=true;}}
  if(v.paused)kick();
  ['touchstart','click','scroll'].forEach(function(ev){
    window.addEventListener(ev,function(){if(v.paused&&!v.controls)kick();},{once:true,passive:true});
  });
});
})();
